module.exports = __webpack_public_path__ + "img/compass-01.ad485d43.svg";